import {NgModule} from '@angular/core';
import {ToolBeltService} from 'app/tool-layer/service/belt/tool-belt.service';
import {ActiveToolService} from 'app/tool-layer/service/active/active-tool.service';

@NgModule({
    providers: [ActiveToolService, ToolBeltService],
})
export class ServiceModule {}
